import React, { useEffect, useRef, useState } from 'react';
import { apiGet, apiPost } from '../../services/apiClient';
import ConfirmModal from '../../modals/confirmModal';
import InformationModal from '../../modals/infoModal';
import FileSelectionModal from '../../modals/fileSelectionModal';

const InstructionsEdit = () => {
    const [files, setFiles] = useState([]);

    const infoModal = useRef(null);
    const confirmModal = useRef(null);
    const fileSelectionModal = useRef(null);

    const loadFiles = () => {
        apiGet("instructions/list")
            .then(data => {
                setFiles(data.entries || []);
            });
    };
    useEffect(loadFiles, []);

    const deleteFile = (fileId, fileName) => {
        const title = 'Удаление инструкции';
        confirmModal.current.open(title, `Вы действительно хотите удалить файл '${fileName}'? Это действие нельзя будет отменить.`)
            .then(() => {
                apiPost("instructions/" + fileId + "/delete")
                    .then(loadFiles)
                    .catch(err => {
                        if (err.message) {
                            infoModal.current.open(title, err.message);
                        }
                    });
            });
    };

    const uploadNewFile = () => {
        const title = 'Загрузка инструкции';
        fileSelectionModal.current.open(title)
            .then(file => {
                let data = new FormData();
                data.append('file', file);

                apiPost("instructions/upload", data)
                    .then(loadFiles)
                    .catch(err => {
                        if (err.message) {
                            infoModal.current.open(title, err.message);
                        }
                    });
            })
            .catch(() => { });
    }

    const filesList = files.map((file) => {
        let fileUrl = getApiBaseUrl() + "instructions/" + file.id + "/download";
        return (
            <div className="row files-row">
                <div className="col-xs-12">
                    <i className="fa fa-paperclip files-row-icon"></i>
                    <a href={fileUrl}>{file.fileName}</a>
                    <i className="fa fa-trash-o files-remove-btn files-row-icon" onClick={() => deleteFile(file.id, file.fileName)}></i>
                </div>
            </div>
        );
    });

    return (
        <div>
            <section className="content-header">
                <div className="row">
                    <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                        <h1>Инструкции</h1>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                        <div className="box box-primary">
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-xs-12">
                                        {filesList}
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <button className="btn btn-flat btn-primary" onClick={uploadNewFile}>
                                                    <i className="fa fa-plus" style={{ marginRight: '4px' }} ></i>
                                                    Загрузить файл
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <InformationModal ref={infoModal} />
            <ConfirmModal ref={confirmModal} />
            <FileSelectionModal ref={fileSelectionModal} />
        </div>
    );
};

export default InstructionsEdit;


// WEBPACK FOOTER //
// ./App/pages/instructions/instructionsEdit.jsx